import React from "react"
import { connectSearchBox } from "react-instantsearch-dom"
import { SearchIcon, Form, TextBox } from "./styles"
export default connectSearchBox(({ refine, ...rest }) => (
    <Form>
        <SearchIcon />
        <TextBox
            type="text"
            placeholder="SEARCH"
            aria-label="SEARCH"
            onChange={e => refine(e.target.value)}
            {...rest}
        />
    </Form>
))
